import { AssetLoader } from '@/shared/utils';

export default async ({ $deferredLoader, $services }) => {
  const info = $services.resolve('info');

  await info.fetch();
  const resourcesUrl = info.resourcesUrl;

  if (!resourcesUrl) {
    return;
  }

  $deferredLoader.appReady.promise
    .then(() => new AssetLoader().load([
      { id: 'amb-icons', src: `${resourcesUrl}/fonts/amb-icons-v1.24/style.css`, type: 'stylesheet' },
      { id: 'lato', src: `${resourcesUrl}/fonts/lato/latofonts.css`, type: 'stylesheet' },
    ]))
    .catch(() => {});
};
